import { createContext } from 'react';

export const ClassConfigContext = createContext();
